import { render, staticRenderFns } from "./pgsForm.vue?vue&type=template&id=b7ad2ecc&"
import script from "./pgsForm.vue?vue&type=script&lang=js&"
export * from "./pgsForm.vue?vue&type=script&lang=js&"
import style0 from "./pgsForm.vue?vue&type=style&index=0&id=b7ad2ecc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports